import { useQuery } from '@tanstack/react-query'

export const queryFonts = () => {

    const query = useQuery({
        queryKey: ['studio-custom-fonts'],
        queryFn: async () => {
            const { data } = await axios.get(route('studio.v1.api.fonts.index'));
            return data?.data || [];
        },
        staleTime: 60 * 1000,
    });

    return query;
}
